module.exports = __webpack_public_path__ + "static/media/ribbon-sm.6122f2b8.gif";